module.exports = __webpack_public_path__ + "static/media/storeActive.e87ca6ec.png";